import { render, staticRenderFns } from "./formbuilderTemplateDataList.vue?vue&type=template&id=4897ece2&scoped=true"
import script from "./formbuilderTemplateDataList.vue?vue&type=script&lang=js"
export * from "./formbuilderTemplateDataList.vue?vue&type=script&lang=js"
import style0 from "./formbuilderTemplateDataList.vue?vue&type=style&index=0&id=4897ece2&prod&lang=scss&scoped=true"
import style1 from "./formbuilderTemplateDataList.vue?vue&type=style&index=1&id=4897ece2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4897ece2",
  null
  
)

export default component.exports